import { IMeeting } from '@utils';
import React, { FC, memo, useMemo } from 'react';
import { Meeting } from './Meeting';
import { ShowMoreButton } from './ShowMoreButton';

interface IMeetingsProps {
  meetings: IMeeting[];
  height: number;
  isActiveDay: boolean;
  onClickShowMore: () => void;
  isWeekendHoliday?: boolean;
}

export const Meetings: FC<IMeetingsProps> = memo(({ meetings, height, isActiveDay, onClickShowMore, isWeekendHoliday = false }) => {

  const MEETING_HEIGHT = 22;
  const OCCUPIED_PLACE = 58;

  const restOfDay = useMemo(() => height - OCCUPIED_PLACE, [height]);
  const avaliableCountOfMeetings = useMemo(() => Math.floor(restOfDay / MEETING_HEIGHT), [restOfDay]);

  /*
    Если в ячейки дня не будут помещаться все встречи
    и количество поместившихся бы встреч не равно кол-ву самих встреч
    и день не в раскрытом виде
    то тогда выводится максимальное количество встреч и кнопка "Еще"
    Иначе все встречи
   */
  return (
    <div className="meeting-list" style={{ gap: isActiveDay ? 4 : 2 }}>
      {restOfDay < meetings?.length * MEETING_HEIGHT
        && avaliableCountOfMeetings !== meetings?.length
        && meetings?.length > 1
        && !isActiveDay ? (
        <>
          {meetings.slice(0, avaliableCountOfMeetings !== 0 ? avaliableCountOfMeetings : 1).map((item, index) =>
            <Meeting
              key={`meeting-${item.meetingName}-${index}`}
              meeting={item}
            />
          )}
          <ShowMoreButton onClick={onClickShowMore} isWeekendHoliday={isWeekendHoliday} />
        </>
      ) : meetings?.map((item, index) =>
        <Meeting
          key={`meeting-${item.meetingName}-${index}`}
          meeting={item}
        />
      )}
    </div>
  );
});
